import { render } from "./why.vue?vue&type=template&id=f04958d8"
import script from "./why.vue?vue&type=script&lang=js"
export * from "./why.vue?vue&type=script&lang=js"

import "./why.vue?vue&type=style&index=0&id=f04958d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__